<template>
  <md-app md-mode="fixed">
    <md-app-toolbar class="md-toolbar md-primary">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">Messaging</h3>
        </div>
      </div>
      <div class="md-toolbar-row">
        <md-tabs class="md-primary" md-sync-route>
          <md-tab md-label="Series" to="/admin/series"></md-tab>
            <md-tab md-label="Pending/Sent" to="/admin/sent"></md-tab>
          </md-tabs>
        </div>
      </div>
    </md-app-toolbar>
    <md-app-content>
  <md-tabs id="messaging-tabs" md-sync-route>
    <md-tab id="tab-series" to="/admin/series">
      <SeriesListView />
    </md-tab>
    <md-tab id="tab-notifications" to="/admin/sent">
      <router-view />
    </md-tab>
  </md-tabs>
    </md-app-content>
  </md-app>
</template>
<script>
import SeriesListView from '@/views/admin/series/List.vue'
export default {
  name: "AdminDashboard",
  components: {
    SeriesListView
  },
  data: function(){
    return {
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style>
#messaging-tabs .md-tabs-navigation{
  display: none;
}
</style>
